import configFontsSlider from "./fontsPage";
import initSwipers from "../swiper/swiperInit";
import openFontListModal from "./fontListModal";

const fontsPage = document.getElementById("fonts");
const fontsContainer = "gallery-blocks-container";
const fontListModalBtn = document.querySelector(".view-font-list");

document.addEventListener("DOMContentLoaded", () => {
  if (fontsPage) {
    initSwipers(fontsContainer, configFontsSlider);
  }

  if (fontListModalBtn) {
    fontListModalBtn.addEventListener("click", () => {
      openFontListModal();
    });
  }
});